import { MINIMUM_SLIDER_YEAR, yearSliderMarks } from '@/components/discovery-filter/constants';
import {
  MINIMUM_SLIDER_PRICE,
  priceRangeSliderMarks,
} from '@/components/discovery-questions-input/utils/price-range-slider-marks';
import { type FiltersState } from '@/app-state/models/filters/state';

export const getIsDefaultFilterState = (filterState: FiltersState) => {
  const {
    selectedBodyStyles,
    selectedLifestyles,
    selectedMakes,
    selectedStarRatings,
    selectedSafetyFeatures,
    selectedPowerTypes,
    selectedPriceRange,
    selectedYearRange,
  } = filterState;

  // Check if arrays are empty for multi-select filters
  const emptyArraysCheck =
    selectedBodyStyles.length === 0 &&
    selectedLifestyles.length === 0 &&
    selectedMakes.length === 0 &&
    selectedStarRatings.length === 0 &&
    selectedSafetyFeatures.length === 0 &&
    selectedPowerTypes.length === 0;

  // Check if range filters are at default values
  const defaultPriceRange =
    selectedPriceRange[0] === MINIMUM_SLIDER_PRICE && selectedPriceRange[1] === priceRangeSliderMarks.at(-1)?.value;

  const defaultYearRange =
    selectedYearRange[0] === MINIMUM_SLIDER_YEAR && selectedYearRange[1] === yearSliderMarks.at(-1)?.value;

  return emptyArraysCheck && defaultPriceRange && defaultYearRange;
};
